'use client'

import type { JSX } from 'react'

import { usePathname, useSearchParams } from 'next/navigation'

import { usePageTitleFor } from './page-title'
import { documentTitle, routeTitle } from './route-title'

/**
 * The app's only <title>: React hoists it into <head> and keeps it in step with
 * the page on screen.
 */
export function DocumentTitle(): JSX.Element {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const page = usePageTitleFor(pathname)
  return (
    <title>{documentTitle(page, routeTitle(pathname, searchParams))}</title>
  )
}
